// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bei_a bhe_bk bhe_bl bhe_bo","SwipeLeftToClose--animating":"bei_b"};